import React from 'react';
import { Box, IconButton } from '@mui/material';
import { Delete as DeleteIcon } from '@mui/icons-material';
import { ConditionTargetSelect } from './ConditionTargetSelect';
import { ConditionOperatorSelect } from './ConditionOperatorSelect';
import { ConditionValueInput } from './ConditionValueInput';
import { useCondition } from '../../../hooks/questionnaire/useCondition';

interface ConditionProps {
  questionIndex: number;
  conditionIndex: number;
  onRemove: () => void;
}

export const Condition: React.FC<ConditionProps> = ({
  questionIndex: questionIndex,
  conditionIndex: conditionIndex,
  onRemove,
}) => {
  const { target, info } = useCondition(questionIndex, conditionIndex);

  return (
    <Box sx={{ mb: 2 }}>
      <Box sx={{ display: 'flex', gap: 2, pt: 1, alignItems: 'center' }}>
        <ConditionTargetSelect
          questionIndex={questionIndex}
          conditionIndex={conditionIndex}
        />
        <ConditionOperatorSelect
          questionIndex={questionIndex}
          conditionIndex={conditionIndex}
          disabled={!target}
        />
        <ConditionValueInput
          questionIndex={questionIndex}
          conditionIndex={conditionIndex}
          info={info}
        />
        <IconButton
          size="small"
          onClick={onRemove}
          color="error"
          sx={{ mt: 1 }}
        >
          <DeleteIcon />
        </IconButton>
      </Box>
    </Box>
  );
};
